import React from "react";
import styles from "./EmptyComponent.module.css";

export default function EmptyComponent({ children }) {
	return <div className={styles.emptyComponent}>{children}</div>;
}
